import React from 'react';
import { Box, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InsightsIcon from '@mui/icons-material/Insights';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { CoachmarkCanvas, HighlightFrame } from '../../../../components/field-coachmark/CoachmarkSkeleton';
import type { CoachmarkState } from '../../../../components/field-coachmark/FieldCoachmark';

const SAMPLE_SCOPE = 'Empresa 001 · Filial 01';

interface AreaProps {
  icon: React.ReactNode;
  label: string;
  scoped?: boolean;
}

const Area = ({ icon, label, scoped }: AreaProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <Box sx={{ display: 'flex', color: scoped ? 'primary.main' : 'text.disabled', fontSize: 12 }}>{icon}</Box>
    <Typography sx={{ fontSize: 10.5, color: 'text.primary', flexGrow: 1 }}>{label}</Typography>
    <Typography
      sx={{
        fontSize: 9.5,
        fontWeight: scoped ? 600 : 400,
        color: scoped ? 'primary.main' : 'text.disabled',
        whiteSpace: 'nowrap',
      }}
    >
      {scoped ? 'só do escopo' : 'tudo'}
    </Typography>
  </Box>
);

const AREAS = [
  { key: 'followup', icon: <MedicalInformationIcon sx={{ fontSize: 12 }} />, label: 'Followup' },
  { key: 'relatorios', icon: <AssessmentIcon sx={{ fontSize: 12 }} />, label: 'Relatórios' },
  { key: 'colaboradores', icon: <PeopleAltIcon sx={{ fontSize: 12 }} />, label: 'Colaboradores' },
  { key: 'home', icon: <InsightsIcon sx={{ fontSize: 12 }} />, label: 'Home › totais' },
];

const Screen = ({ scoped }: { scoped?: boolean }) => (
  <CoachmarkCanvas>
    {scoped ? (
      <HighlightFrame sx={{ alignSelf: 'flex-start' }}>
        <ApartmentIcon sx={{ fontSize: 12, color: 'primary.main' }} />
        <Typography sx={{ fontSize: 10, fontWeight: 600, color: 'text.primary' }}>{SAMPLE_SCOPE}</Typography>
      </HighlightFrame>
    ) : (
      <Typography sx={{ fontSize: 10, color: 'text.disabled' }}>Escopo cadastrado é ignorado</Typography>
    )}

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {AREAS.map(area => (
        <Area key={area.key} icon={area.icon} label={area.label} scoped={scoped} />
      ))}
    </Box>
  </CoachmarkCanvas>
);

export const useUserAccessScopeStates: CoachmarkState[] = [
  { label: 'Marcado', preview: <Screen scoped /> },
  { label: 'Desmarcado', preview: <Screen /> },
];
